import { ContentTypes } from '@/client/services/api/graphql/gql/graphql';
import { useNavigate } from 'react-router-dom';

export const useNavigateByContentType = () => {
  const navigate = useNavigate();

  type ContentTypesWithOmission = Exclude<
    ContentTypes,
    | ContentTypes.Poll
    | ContentTypes.MultiSessionWorkshopSession
    | ContentTypes.Presentation
    | ContentTypes.Quiz
  >;

  const contentTypeMap: Record<ContentTypesWithOmission | string, string> = {
    [ContentTypes.Article]: 'article',
    article: 'article',
    [ContentTypes.Assessment]: 'assessment',
    assessment: 'assessment',
    [ContentTypes.File]: 'file',
    file: 'file',
    [ContentTypes.Video]: 'video',
    video: 'video',
    [ContentTypes.ImportedContent]: 'imported-content',
    imported_content: 'imported-content',
    [ContentTypes.Journey]: 'journey',
    journey: 'journey',
    [ContentTypes.Scorm]: 'scorm',
    scorm: 'scorm',
    [ContentTypes.Event]: 'event',
    event: 'event',
    [ContentTypes.Media]: 'media',
    media: 'media',
    [ContentTypes.MultiSessionWorkshop]: 'multi-session-workshop',
    multi_session_workshop: 'multi-session-workshop',
    [ContentTypes.Track]: 'track',
    track: 'track',
    [ContentTypes.Workshop]: 'workshop',
    workshop: 'workshop',
  };

  const navigateByContentType = (
    contentType: ContentTypesWithOmission | string,
    contentId: string,
  ) => navigate(`/${contentTypeMap[contentType]}/${contentId}`);

  return {
    contentTypeMap,
    navigateByContentType,
  };
};
